<template>
  <div class="seamless-scroll-container">
    <image-horizontal-scroll></image-horizontal-scroll>

    <image-horizontal-scroll :customClassOption="{step: 1}"></image-horizontal-scroll>

    <image-horizontal-scroll :customClassOption="{step: 1.1}"></image-horizontal-scroll>
  </div>
</template>
<script>
import ImageHorizontalScroll from './ImageHorizontalScroll.vue'

export default {
  name: 'SeamlessScroll',
  components: {
    ImageHorizontalScroll
  },
  data() {
    return {
    }
  },
}
</script>
<style lang="stylus" scoped></style>
